// Une date de naissance est une date calendaire : le 28 doit rester le 28 quel que soit le
// fuseau du navigateur. L'API la stocke et la renvoie à minuit UTC ("1973-04-28T00:00:00.000Z") ;
// on lit donc toujours le jour en UTC, jamais en heure locale (sinon un navigateur à l'ouest de
// l'UTC affiche la veille).

const pad = n => String(n).padStart(2, '0')

const utcParts = value => {
  if (!value) return null
  const date = value instanceof Date ? value : new Date(value)
  if (isNaN(date)) return null
  return { year: date.getUTCFullYear(), month: date.getUTCMonth(), day: date.getUTCDate() }
}

// Affichage : "28/04/1973"
export const formatBirthdate = value => {
  const parts = utcParts(value)
  return parts ? `${pad(parts.day)}/${pad(parts.month + 1)}/${parts.year}` : ''
}

// API -> Datepicker : Date à minuit LOCAL du même jour calendaire (le Datepicker travaille en local)
export const birthdateToPickerDate = value => {
  const parts = utcParts(value)
  return parts ? new Date(parts.year, parts.month, parts.day) : null
}

// Datepicker -> API : Date à minuit UTC du jour choisi (et non minuit local, qui donnerait la veille en UTC)
export const pickerDateToBirthdate = date =>
  date instanceof Date && !isNaN(date)
    ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
    : date
